import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSelectAsync from 'react-select/async';
import SelectOption from 'components/core/SelectOption';
import apiClient from 'apiClient';
import debounce from 'debounce-promise';

import { REACT_SELECT_STYLES } from 'helpers/styles';

class ProjectSelect extends Component {
  constructor() {
    super();

    this.state = {
      options: [],
      loading: true,
    };

    this.debouncedLoadProjects = debounce(this.loadProjects, 250, {
      leading: true,
    });
  }

  async componentDidMount() {
    const projectOptions = await this.loadProjects();
    this.setState({ options: projectOptions, loading: false });
  }

  loadProjects = async (input) => {
    const { companyId, ignoreProjectId } = this.props;
    const path = `companies/${companyId}/search/projects`;

    try {
      const projects = await apiClient.get(path, { q: input });

      let filteredProjects = projects;
      if (ignoreProjectId) {
        filteredProjects = projects.filter((project) => {
          return project.id !== ignoreProjectId;
        });
      }

      return filteredProjects.map((project) => {
        return {
          ...project,
          identifier:
            `${project.name} ${project.street_address_1}`.toLowerCase(),
        };
      });
    } catch (e) {
      return [];
    }
  };

  renderLabel = (project) => {
    let displayName = project.name;
    if (
      (project.name && project.name.toLowerCase() === 'unnamed') ||
      project.name === project.street_address_1
    ) {
      displayName = null;
    }

    return [displayName, project.street_address_1]
      .filter((p) => !!p)
      .join(' - ');
  };

  render() {
    return (
      <ReactSelectAsync
        name="project"
        autofocus
        isClearable
        isLoading={this.state.loading}
        tabSelectsValue={false}
        defaultValue={this.props.initialValue}
        getOptionLabel={this.renderLabel}
        getOptionValue={({ id }) => id}
        placeholder={this.props.placeholder}
        defaultOptions={this.state.options}
        loadOptions={async (input) => this.debouncedLoadProjects(input)}
        onInputChange={(newValue) => newValue}
        onChange={this.props.onChange}
        styles={REACT_SELECT_STYLES}
        components={{
          Option: (props) => {
            const name = props.data.name;
            const address = props.data.street_address_1;

            let primaryDescription = name;
            let secondaryDescription = address;

            if (
              (name && name.toLowerCase() === 'unnamed') ||
              name === address ||
              !name
            ) {
              primaryDescription = address;
              secondaryDescription = null;
            }

            return (
              <SelectOption
                isFocused={props.isFocused}
                isSelected={props.isSelected}
                primaryDescription={primaryDescription}
                secondaryDescription={secondaryDescription}
                innerRef={props.innerRef}
                innerProps={props.innerProps}
              />
            );
          },
        }}
      />
    );
  }
}
ProjectSelect.propTypes = {
  companyId: PropTypes.string.isRequired,
  ignoreProjectId: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  initialValue: PropTypes.object,
};

ProjectSelect.defaultProps = {
  onChange: () => {},
  placeholder: '',
};

export default ProjectSelect;
